module.exports = __webpack_public_path__ + "img/smart24_title.b2ac689b.png";